import { Notches } from "@phosphor-icons/react";
import clsx from "clsx";
import { useState, useEffect } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

export default function TripleLayout({
  left,
  right,
  footer,
  header,
  cx,
}: {
  left: React.ReactNode;
  right: React.ReactNode[];
  footer?: React.ReactNode;
  header?: React.ReactNode;
  cx?: string;
}) {
  const [direction, setDirection] = useState<"horizontal" | "vertical">(
    "horizontal"
  );

  useEffect(() => {
    const handleResize = () => {
      setDirection(window.innerWidth <= 768 ? "vertical" : "horizontal");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={clsx("w-full flex flex-col relative", cx)}>
      <div>{header}</div>
      <div className="flex-1">
        <PanelGroup direction={direction} className="resize overflow-auto relative h-full min-h-[400px]">
          {/* Sol Panel */}
          <Panel
            defaultSize={40}
            className="min-w-72 bg-surface-1 rounded-l-2xl border border-r-0 border-white/[0.08]"
          >
            {left}
          </Panel>

          <div className="group pr-1 bg-surface-2 border-y border-white/[0.06]">
            <PanelResizeHandle className="resizer w-0.5 h-full rounded-full cursor-ew-resize md:cursor-ns-resize" />
          </div>

          {/* Sağ Panel */}
          {right.length > 1 ? (
            <Panel className="min-w-96 border border-l-0 border-white/[0.06] rounded-r-2xl">
              <PanelGroup direction="vertical" className="h-full">
                <Panel defaultSize={50} className="rounded-tr-2xl">
                  {right[0]}
                </Panel>

                <div className="group py-1 bg-surface-2">
                  <PanelResizeHandle className="resizer h-0.5 w-full cursor-ns-resize" />
                </div>

                <Panel defaultSize={50} className="rounded-br-2xl">
                  {right[1]}
                </Panel>
              </PanelGroup>
            </Panel>
          ) : (
            <Panel className="min-w-96 border border-l-0 border-white/[0.06] rounded-r-2xl">
              {right[0]}
            </Panel>
          )}

          <div className="absolute right-0 bottom-0 w-5 h-5 pointer-events-none overflow-hidden">
            <Notches
              size={20}
              weight="bold"
              className="translate-[0] text-white/30"
            />
          </div>
        </PanelGroup>
      </div>
      <div className="mt-4">{footer}</div>
    </div>
  );
}
